import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private userInfoService: UserInfoService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.userInfoService.isUserLoggedIn()) {
      if (route.url.some(segment => segment.path === 'login')) {
        this.router.navigate(['/']);
        return false;
      }
      return true;
    } else {
      if (route.url.some(segment => segment.path === 'profile')) {
        this.router.navigate(['/ar/login']);
        return false;
      } if (route.url.some(segment => segment.path === 'course')) {
        this.router.navigate(['/ar/login']);
        return false;
      }
    }
    return true;
  }
}
